import React, { ChangeEvent, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CRow,
  CTabContent,
} from '@coreui/react-pro'
import { useCreateSection } from './hooks'
import { setSection, submitCreateSection } from './model'

export const CreateSection = () => {
  const [validated, setValidated] = useState(false)

  const { section } = useCreateSection()

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value = event.currentTarget.value

    setSection({
      ...section,
      [event.currentTarget.name]: value,
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitCreateSection(section)
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Create section</strong>
      </CCardHeader>
      <CCardBody>
        <CTabContent className="pt-3">
          <CForm noValidate validated={validated} onSubmit={handleSubmit}>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="name"
                  name="name"
                  value={section.name}
                  onChange={handleChange}
                  label="Name"
                  required
                />
              </CCol>
            </CRow>
            <CButton className="mb-3" type="submit">
              Create
            </CButton>
          </CForm>
        </CTabContent>
      </CCardBody>
    </CCard>
  )
}
